import image1 from "../../assets/images/hero-bg.png";
const elements = [
  {
    bg: image1,
    title: "Seguro de vida",
    subtitle: "La mayor protección al menor costo.",
    text: "Sabemos lo importante que es para ti cuidar de los tuyos.",
    link: "#",
  },
  {
    bg: image1,
    title: "Seguro de vida 2",
    subtitle: "La mayor protección al menor costo.",
    text: "Sabemos lo importante que es para ti cuidar de los tuyos.",
    link: "#",
  },
  {
    bg: image1,
    title: "Seguro de vida 3",
    subtitle: "La mayor protección al menor costo.",
    text: "Sabemos lo importante que es para ti cuidar de los tuyos.",
    link: "#",
  },
  {
    bg: image1,
    title: "Seguro de vida 4",
    subtitle: "La mayor protección al menor costo.",
    text: "Sabemos lo importante que es para ti cuidar de los tuyos.",
    link: "#",
  },
];

export default elements;
